
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/base/SEOHead';

const MeetTeamPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEOHead 
        title="Meet Our Team - HP Inc Consulting Services | Expert Safety Professionals"
        description="Meet the expert safety professionals at HP Inc Consulting Services. Our team of certified safety consultants, industrial hygienists, and OSHA compliance specialists."
        keywords="safety consulting team, safety professionals, OSHA consultants, industrial hygienists, safety experts, certified safety professionals, workplace safety specialists"
        canonical="https://hpincconsultant.com/meet-team"
        ogTitle="Meet Our Team - Expert Safety Professionals"
        ogDescription="Meet our team of certified safety consultants and workplace safety experts dedicated to providing professional safety consulting services."
        ogUrl="https://hpincconsultant.com/meet-team"
      />
      <Header />
      <main>
        {/* Hero Section */}
        <section className="relative bg-gradient-to-r from-blue-900 to-blue-700 text-white py-20">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                Meet Our Team
              </h1>
              <p className="text-xl mb-8">
                Experienced safety professionals dedicated to protecting your workforce
              </p>
            </div>
          </div>
        </section>

        {/* Team Section */}
        <section className="py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto">
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                <div className="text-center">
                  <div className="w-32 h-32 bg-gray-300 rounded-full mx-auto mb-4"></div>
                  <h3 className="text-xl font-semibold mb-2">Eric Fonseca</h3>
                  <p className="text-blue-600 mb-2">CEO &amp; Lead Safety Consultant</p>
                  <p className="text-gray-600 text-sm">20+ years of experience in workplace safety and OSHA compliance.</p>
                </div>
                <div className="text-center">
                  <div className="w-32 h-32 bg-gray-300 rounded-full mx-auto mb-4"></div>
                  <h3 className="text-xl font-semibold mb-2">Mani Maleki</h3>
                  <p className="text-blue-600 mb-2">Industrial Hygienist</p>
                  <p className="text-gray-600 text-sm">Certified industrial hygienist specializing in air quality assessments.</p>
                </div>
                <div className="text-center">
                  <div className="w-32 h-32 bg-gray-300 rounded-full mx-auto mb-4"></div>
                  <h3 className="text-xl font-semibold mb-2">Mike Davis</h3>
                  <p className="text-blue-600 mb-2">Training Specialist</p>
                  <p className="text-gray-600 text-sm">Expert in OSHA training programs and safety education.</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default MeetTeamPage;
